import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import BirthdaySongMVP from './components/BirthdaySongMVP';
import SuccessPage from './pages/SuccessPage';
import AdminPage from './pages/AdminPage';
import LandingPage from './pages/LandingPage';
import './App.css';

// ============================================
// TOGGLE: Landing Page vs Main App
// ============================================
// Set to true to show landing page (pre-launch)
// Set to false to show main app (after launch)
const SHOW_LANDING_PAGE = true; // 👈 Change this to toggle

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={SHOW_LANDING_PAGE ? <LandingPage /> : <BirthdaySongMVP />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/admin" element={<AdminPage />} />
        {SHOW_LANDING_PAGE && <Route path="/app" element={<BirthdaySongMVP />} />}
      </Routes>
    </Router>
  );
}

export default App;
